var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "div",
                { attrs: { id: "searchBox" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "xhname" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入型号" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.xhname,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "xhname", $$v)
                          },
                          expression: "searchForm.xhname",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "source" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入品牌" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.source,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "source", $$v)
                          },
                          expression: "searchForm.source",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "company" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入交易商" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "company", $$v)
                          },
                          expression: "searchForm.company",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入商品名称" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "title", $$v)
                          },
                          expression: "searchForm.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text", id: "closeSearchBtn" },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.word) + " "),
                      _c("i", {
                        class: _vm.showAll
                          ? "el-icon-arrow-up "
                          : "el-icon-arrow-down",
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.handleSearchBtn },
                    },
                    [_vm._v("搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetBtn },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-table search-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "row-style": _vm.tableRowStyle,
              },
            },
            [
              _c("el-table-column", { attrs: { label: "序号", prop: "id" } }),
              _c("el-table-column", {
                attrs: { label: "商品编码", prop: "cid", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", prop: "title" },
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname", width: "200" },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
              }),
              _c("el-table-column", {
                attrs: { label: "入库/出库数量", prop: "number", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "是否含税", prop: "shui" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          staticStyle: { "font-size": "20px" },
                          style:
                            scope.row.shui == "T"
                              ? "color:green"
                              : "color: red",
                          attrs: {
                            type: "text",
                            icon:
                              scope.row.shui == "T"
                                ? "el-icon-success"
                                : "el-icon-error",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购价/销售价（含税）",
                  prop: "price",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "产地", prop: "address" },
              }),
              _c("el-table-column", {
                attrs: { label: "包装", prop: "baozhuang" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "入库/出库日期",
                  prop: "settime",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "供应商/客户名称",
                  prop: "company",
                  width: "300",
                },
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
            attrs: {
              "current-page": _vm.selectPage.pageNum,
              "page-sizes": [20, 50, 100, 200],
              "page-size": _vm.selectPage.pageSize,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.allNum,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }